
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    budget: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errors, setErrors] = useState<Record<string, string>>({});

  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    
    if (!formData.name.trim()) newErrors.name = 'Ad Soyad gereklidir';
    if (!formData.email.trim()) newErrors.email = 'E-posta gereklidir';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Geçerli bir e-posta adresi girin';
    if (!formData.phone.trim()) newErrors.phone = 'Telefon numarası gereklidir';
    if (!formData.service) newErrors.service = 'Hizmet seçimi gereklidir';
    if (!formData.message.trim()) newErrors.message = 'Mesaj gereklidir';
    else if (formData.message.length > 500) newErrors.message = 'Mesaj 500 karakteri geçemez';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formDataToSend = new URLSearchParams();
      Object.entries(formData).forEach(([key, value]) => {
        formDataToSend.append(key, value);
      });

      const response = await fetch('https://readdy.ai/api/form/d3bph6kef3sotc9j5nq0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formDataToSend.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          service: '',
          budget: '',
          message: ''
        });
      } else {
        throw new Error('Form gönderimi başarısız');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  return (
    <section id="iletisim" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Projeni <span className="text-blue-400">Konuşalım</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Fikirlerini gerçeğe dönüştürmek için hemen iletişime geç. 
            Ücretsiz danışmanlık ve detaylı teklif için formu doldur.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-white mb-6">İletişim Bilgileri</h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line w-6 h-6 flex items-center justify-center text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-white mb-1">Adres</h4>
                    <p className="text-gray-300">
                      Şehitler Mahallesi 127. Sokak No:26<br />
                      Salihli, Manisa 45310
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line w-6 h-6 flex items-center justify-center text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-white mb-1">Telefon</h4>
                    <a 
                      href="tel:+905060993996" 
                      className="text-blue-400 hover:text-blue-300 transition-colors cursor-pointer"
                      aria-label="Telefon numarasını ara"
                    >
                      +90 506 099 39 96
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line w-6 h-6 flex items-center justify-center text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-white mb-1">E-posta</h4>
                    <a 
                      href="mailto:yazilimvewebtasarim@gmail.com" 
                      className="text-blue-400 hover:text-blue-300 transition-colors cursor-pointer"
                      aria-label="E-posta gönder"
                    >
                      yazilimvewebtasarim@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line w-6 h-6 flex items-center justify-center text-white"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-white mb-1">Çalışma Saatleri</h4>
                    <p className="text-gray-300">
                      Pazartesi - Cuma: 09:00 - 18:00<br />
                      Cumartesi: 10:00 - 16:00
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Social Media */}
            <div>
              <h4 className="text-lg font-semibold text-white mb-4">Sosyal Medya</h4>
              <div className="flex space-x-4">
                <a 
                  href="https://linkedin.com/company/ayyildizdigital" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-blue-400"
                  aria-label="LinkedIn profilimizi ziyaret edin"
                >
                  <i className="ri-linkedin-fill w-5 h-5 flex items-center justify-center text-white"></i>
                </a>
                <a 
                  href="https://instagram.com/ayyildizdigital" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-gray-800 hover:bg-pink-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-pink-400"
                  aria-label="Instagram profilimizi ziyaret edin"
                >
                  <i className="ri-instagram-fill w-5 h-5 flex items-center justify-center text-white"></i>
                </a>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-gray-800 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-white mb-6">Teklif Al</h3>
            
            {submitStatus === 'success' && (
              <div className="mb-6 p-4 bg-green-600 text-white rounded-lg">
                <div className="flex items-center">
                  <i className="ri-check-circle-line w-5 h-5 flex items-center justify-center mr-2"></i>
                  Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.
                </div>
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="mb-6 p-4 bg-red-600 text-white rounded-lg">
                <div className="flex items-center">
                  <i className="ri-error-warning-line w-5 h-5 flex items-center justify-center mr-2"></i>
                  Bir hata oluştu. Lütfen tekrar deneyin veya telefon ile iletişime geçin.
                </div>
              </div>
            )}

            <form onSubmit={handleSubmit} id="contact-form" data-readdy-form className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-2">
                    Ad Soyad *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-3 bg-gray-700 border rounded-lg text-white text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${errors.name ? 'border-red-500' : 'border-gray-600'}`}
                    placeholder="Adınız ve soyadınız"
                    aria-describedby={errors.name ? 'name-error' : undefined}
                  />
                  {errors.name && (
                    <p id="name-error" className="mt-1 text-sm text-red-400" role="alert">
                      {errors.name}
                    </p>
                  )}
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
                    E-posta *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-3 bg-gray-700 border rounded-lg text-white text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${errors.email ? 'border-red-500' : 'border-gray-600'}`}
                    placeholder="ornek@email.com"
                    aria-describedby={errors.email ? 'email-error' : undefined}
                  />
                  {errors.email && (
                    <p id="email-error" className="mt-1 text-sm text-red-400" role="alert">
                      {errors.email}
                    </p>
                  )}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-300 mb-2">
                    Telefon *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className={`w-full px-4 py-3 bg-gray-700 border rounded-lg text-white text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors ${errors.phone ? 'border-red-500' : 'border-gray-600'}`}
                    placeholder="+90 5XX XXX XX XX"
                    aria-describedby={errors.phone ? 'phone-error' : undefined}
                  />
                  {errors.phone && (
                    <p id="phone-error" className="mt-1 text-sm text-red-400" role="alert">
                      {errors.phone}
                    </p>
                  )}
                </div>

                <div>
                  <label htmlFor="service" className="block text-sm font-medium text-gray-300 mb-2">
                    Hizmet *
                  </label>
                  <div className="relative">
                    <select
                      id="service"
                      name="service"
                      value={formData.service}
                      onChange={handleInputChange}
                      className={`w-full px-4 py-3 pr-8 bg-gray-700 border rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors appearance-none cursor-pointer ${errors.service ? 'border-red-500' : 'border-gray-600'}`}
                      aria-describedby={errors.service ? 'service-error' : undefined}
                    >
                      <option value="">Hizmet seçin</option>
                      <option value="web-tasarim">Web Tasarımı</option>
                      <option value="e-ticaret">E-ticaret</option>
                      <option value="mobil-uygulama">Mobil Uygulama</option>
                      <option value="seo">SEO Hizmetleri</option>
                      <option value="dijital-pazarlama">Dijital Pazarlama</option>
                      <option value="diger">Diğer</option>
                    </select>
                    <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                  </div>
                  {errors.service && (
                    <p id="service-error" className="mt-1 text-sm text-red-400" role="alert">
                      {errors.service}
                    </p>
                  )}
                </div>
              </div>

              <div>
                <label htmlFor="budget" className="block text-sm font-medium text-gray-300 mb-2">
                  Bütçe Aralığı
                </label>
                <div className="relative">
                  <select
                    id="budget"
                    name="budget"
                    value={formData.budget}
                    onChange={handleInputChange}
                    className="w-full px-4 py-3 pr-8 bg-gray-700 border border-gray-600 rounded-lg text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors appearance-none cursor-pointer"
                  >
                    <option value="">Bütçe seçin (isteğe bağlı)</option>
                    <option value="5000-15000">5.000₺ - 15.000₺</option>
                    <option value="15000-30000">15.000₺ - 30.000₺</option>
                    <option value="30000-50000">30.000₺ - 50.000₺</option>
                    <option value="50000+">50.000₺+</option>
                  </select>
                  <i className="ri-arrow-down-s-line w-5 h-5 flex items-center justify-center absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                </div>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2">
                  Proje Detayları *
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={5}
                  value={formData.message}
                  onChange={handleInputChange}
                  maxLength={500}
                  className={`w-full px-4 py-3 bg-gray-700 border rounded-lg text-white text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors resize-vertical ${errors.message ? 'border-red-500' : 'border-gray-600'}`}
                  placeholder="Projeniz hakkında detayları paylaşın..."
                  aria-describedby={errors.message ? 'message-error' : 'message-counter'}
                />
                <div className="flex justify-between items-center mt-1">
                  {errors.message ? (
                    <p id="message-error" className="text-sm text-red-400" role="alert">
                      {errors.message}
                    </p>
                  ) : (
                    <span></span>
                  )}
                  <span id="message-counter" className="text-sm text-gray-400">
                    {formData.message.length}/500
                  </span>
                </div>
              </div>

              <Button
                type="submit"
                variant="primary"
                size="lg"
                disabled={isSubmitting}
                className="w-full whitespace-nowrap cursor-pointer focus:outline-none focus:ring-4 focus:ring-blue-300"
                aria-label="Formu gönder"
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin w-5 h-5 flex items-center justify-center mr-2"></i>
                    Gönderiliyor...
                  </>
                ) : (
                  <>
                    Teklif Al
                    <i className="ri-send-plane-line w-5 h-5 flex items-center justify-center ml-2"></i>
                  </>
                )}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
